import {
  AddErrorMessage,
  MessageDictionary,
} from 'pages/AutomationEngine/messageDictionary';

import { DestinationFieldOptionsKey } from '../llm-common/constants';
import { ApiDestination } from '../llm-common/llm-types';
import { displayNameToOptionWithDeleted } from '__services/helpers';
import {
  checkDeleted,
  displayNameDescriptor,
} from '__pages/AutomationEngine/helpers';

// infer destinationField from destination options
const getDestinationField = (
  relatedObjectField: any,
  variable: any
): DestinationFieldOptionsKey =>
  relatedObjectField
    ? 'related_object_field'
    : variable
      ? 'variable'
      : 'this_object_field';

type ApiObject = {
  inputField: any;
  modelName: string;
  businessPluginApp: any;
  prompt: string;
  htmlPrompt: string;
  mergeFieldValidation: any;
  defaultToValue: any;
  destinations: ApiDestination[];
};

const forFlow = (
  apiObject: ApiObject,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary,
  stepType: any
) => {
  const {
    inputField,
    modelName,
    businessPluginApp,
    prompt,
    htmlPrompt,
    mergeFieldValidation,
    defaultToValue,
    destinations,
  } = apiObject;

  const { relatedObjectField, field, variable, conflictResolution } =
    destinations[0];

  const destinationField = getDestinationField(relatedObjectField, variable);

  checkDeleted(
    messageDictionary,
    addErrorMessage,
    inputField,
    displayNameDescriptor
  );

  checkDeleted(
    messageDictionary,
    addErrorMessage,
    relatedObjectField,
    displayNameDescriptor
  );

  checkDeleted(
    messageDictionary,
    addErrorMessage,
    field,
    displayNameDescriptor
  );

  if (!modelName || !businessPluginApp) {
    addErrorMessage(messageDictionary.llmPluginAppIsMissing);
  }

  const flow = {
    inputField: displayNameToOptionWithDeleted(
      inputField,
      messageDictionary.deleted
    ),
    modelName: modelName || null,
    businessPluginAppId: businessPluginApp?.id || null,
    prompt,
    htmlPrompt,
    mergeFieldValidation,
    defaultToValue,
    destinations: [
      {
        field: field
          ? displayNameToOptionWithDeleted(field, messageDictionary.deleted)
          : null,
        relatedObjectField:
          !field?.deleted && relatedObjectField // if field is deleted always return null
            ? displayNameToOptionWithDeleted(
                relatedObjectField,
                messageDictionary.deleted
              )
            : null,
        variable: variable
          ? displayNameToOptionWithDeleted(
              { ...variable, displayName: undefined },
              messageDictionary.deleted
            )
          : null,
        conflictResolution: conflictResolution || 'overwrite',
      },
    ],
    destinationField,
  };

  return flow;
};

const forApi = (
  step: any,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary
) => {
  const {
    inputField,
    modelName,
    businessPluginAppId,
    prompt,
    htmlPrompt,
    mergeFieldValidation,
    destinations,
  } = step.details;

  const { relatedObjectField, field, variable, conflictResolution } =
    destinations[0];

  const api = {
    ...step,
    details: {
      inputField: inputField?.value,
      modelName,
      businessPluginAppId,
      prompt,
      htmlPrompt,
      mergeFieldValidation,
      defaultToValue: 'unknown',
      destinations: [
        {
          relatedObjectField: relatedObjectField?.value,
          field: field?.value,
          variable: variable?.label,
          conflictResolution: conflictResolution || 'overwrite',
        },
      ],
    },
  };

  return api;
};

export const fileContentExtractionDTO = {
  forApi,
  forFlow,
};
